import { TypeUtils } from '@vectord/utils';

export default function parseBlacklistLearnerRequest({ currentPage, filters }) {
  const { learnerEmail, superBatch } = filters;

  let email;
  if (TypeUtils.isPresent(learnerEmail)) {
    email = learnerEmail;
  }

  return {
    page: currentPage,
    filters: {
      learnerEmail: email,
      superBatch: superBatch,
    },
  };
}
